import {isEmpty, startCase} from 'lodash';
import {LenderCommissionRateUtil} from '../utils/lender/lender-commission-rate.util';

export class LenderPassbookRecord {
    amount: number;
    loanId: string;
    timestamp: Date;
    transactionType: string;

    private readonly lenderCommissionRateUtil: LenderCommissionRateUtil;

    private transactionTypeMap = new Map<string, string>()
        .set('emi_payment', 'EMI Received')
        .set('manual_invest', 'Invested in Loan')
        .set('auto_invest', 'Invested in Loan')
        .set('hybrid_invest', 'Invested in Loan')
        .set('prepayment', 'Prepayment Received')
        .set('loan_auto_invest', 'Invested in Loan')
        .set('Sent to wallet', 'Sent to finzy Wallet')
        .set('amountreversed', 'Sent to finzy Wallet')
        .set('amount reversed', 'Sent to finzy Wallet')
        .set('Sent To Bank Account', 'Sent to registered Bank Account')
        .set('Credit through Virtual Account', 'Transfer to finzy wallet from bank account')
        .set('Credit by Ops', 'Transfer to finzy wallet from bank account')
        .set('Debit by Ops', 'Sent to registered bank account from finzy wallet')
        .set('Loan closed', 'Investment Reversed - due to loan closure')
        .set('commission_emi_payment', 'finzy processing fee on EMI payment')
        .set('Sub Standard Asset', 'Sub Standard Asset')
        .set('Loss Asset', 'Loss Asset')
        .set(LenderPassbookReference.WriteOff, LenderPassbookReference.WriteOff)
        .set(LenderPassbookReference.WriteBack, LenderPassbookReference.WriteBack);

    private DescriptionTypeMap = new Map<string, string>()
        .set('SGST', '9% SGST on the finzy processing fee.')
        .set('CGST', '9% CGST on the finzy processing fee.')
        .set('IGST', '18% IGST on the finzy processing fee.')
        .set('IGST', '18% IGST on the finzy processing fee.')
        .set('Investment Reversed', 'Investment in loan is reversed as per request.')
        .set('Loan closed', 'If the loan was part of a finzyPRO portfolio, we will look for a new loan. If the loan was part of a Manual portfolio, we will credit the money back to your finzy wallet.')
        .set('commission_emi_payment', '% on the total EMI collected.')
        .set('Sub Standard Asset', '50% principal written-off on marking the loan as Sub Standard Asset')
        .set('Loss Asset', '50% principal written-off on marking the loan as Loss Asset');

    private RouterLinKEnabledTransactionTypes = ['manual_invest', 'auto_invest', 'loan_auto_invest', 'emi_payment', 'hybrid_invest', 'Total Settlement Amount',
        LenderPassbookReference.WriteOff, LenderPassbookReference.WriteBack, 'Principal written-off due to loan restructure',
        'Principal written-back due to loan restructure', 'Upfront payment received due to loan restructure'];

    constructor(amount: number, timestamp: Date, transactionType: string, loanId: string, lenderCommissionRateUtil?: LenderCommissionRateUtil) {
        this.amount = amount;
        this.loanId = loanId;
        this.timestamp = timestamp;
        this.transactionType = transactionType;
        this.lenderCommissionRateUtil = lenderCommissionRateUtil;
    }

    public getDisplayableTransactionType(): string {
        return this.transactionTypeMap.has(this.transactionType) ? this.transactionTypeMap.get(this.transactionType) : startCase(this.transactionType);
    }

    public getDescription(): string {
        const description = this.DescriptionTypeMap.has(this.transactionType) ? this.DescriptionTypeMap.get(this.transactionType) : '';
        if (this.transactionType === 'commission_emi_payment') {
            const commissionPercentage = this.lenderCommissionRateUtil.getLenderCommissionBy(this.timestamp);
            return `${commissionPercentage}${description}`;
        }
        return description;
    }

    public getRouterLink(): string {
        if (this.RouterLinKEnabledTransactionTypes.includes(this.transactionType) && !isEmpty(this.loanId)) {
            return `/loandetail/${this.loanId}`;
        }
        return undefined;
    }
}

export enum LenderPassbookReference {
    WriteOff = 'Principal written-off due to loan settlement',
    WriteBack = 'Principal written-back due to loan settlement'
}
